let _ = t => t,
  _t,
  _t2;
import styled from 'styled-components';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { css, mediaQuery } from 'academy-common-lib/utils/Styling';
const BlankPageMediaWrapper = styled(UIMediaObject).withConfig({
  displayName: "BlankPageMediaWrapper",
  componentId: "sc-5gw1xm-0"
})(["display:flex;justify-items:center;gap:88px;justify-content:center;> div{margin-left:0;justify-content:center;}.media-body{max-width:372px;}img{margin:0 auto;}", " ", ""], mediaQuery('tablet', css(_t || (_t = _`
      flex-direction: column !important;
      gap: 36px;
      .media-body {
        max-width: none;
      }
    `))), mediaQuery('mobile', css(_t2 || (_t2 = _`
      img {
        width: 100%;
      }
    `))));
export default BlankPageMediaWrapper;